import { useEffect } from 'react';

/**
 * @param {HTMLElement} ref 
 * @param {Function} callback
 * @description Adds an on-click event listener and removes it on clean-up.
 * The listener executes the callback when the event target is outside of
 * the specified DOM node.
 */
const useDocumentClick = (ref, callback) => {
    const handleClick = (e) => {
        if (ref.current && !ref.current.contains(e.target)) {
            callback();
        }
    };

    useEffect(() => {
        document.addEventListener('click', handleClick);

        return () => {
            document.removeEventListener('click', handleClick);
        };
    });
};

export default useDocumentClick;
